// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file mobility/v1/common.proto (package mobility.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { DayOfWeek } from "../../google/type/dayofweek_pb";
import { file_google_type_dayofweek } from "../../google/type/dayofweek_pb";
import type { TimeOfDay } from "../../google/type/timeofday_pb";
import { file_google_type_timeofday } from "../../google/type/timeofday_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mobility/v1/common.proto.
 */
export const file_mobility_v1_common: GenFile = /*@__PURE__*/
  fileDesc("Chhtb2JpbGl0eS92MS9jb21tb24ucHJvdG8SC21vYmlsaXR5LnYxIvgBCg9UcmFuc3BvcnRBZ2VuY3kSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRIUCgxmdWxsX2FkZHJlc3MYAyABKAkSMwoNb3BlbmluZ19ob3VycxgEIAMoCzIcLm1vYmlsaXR5LnYxLkRheU9wZW5pbmdIb3VycxIYChBvcGVyYXRlc19vbl9jYWxsGAUgASgIEg0KBXBob25lGAYgASgJEhUKDW9uX2NhbGxfcGhvbmUYByABKAkSHAoUb3V0X29mX29wZW5pbmdfaG91cnMYCCABKAgSEQoJaW1hZ2VfdXJsGAkgASgJEg8KB29mZmxpbmUYCiABKAgibQoPRGF5T3BlbmluZ0hvdXJzEisKC2RheV9vZl93ZWVrGAEgASgOMhYuZ29vZ2xlLnR5cGUuRGF5T2ZXZWVrEi0KCWludGVydmFscxgCIAMoCzIaLm1vYmlsaXR5LnYxLk9wZW5pbmdQZXJpb2QiZgoNT3BlbmluZ1BlcmlvZBIpCglvcGVuX3RpbWUYASABKAsyFi5nb29nbGUudHlwZS5UaW1lT2ZEYXkSKgoKY2xvc2VfdGltZRgCIAEoCzIWLmdvb2dsZS50eXBlLlRpbWVPZkRheSKxAQoFUGxhY2USEAoIbGF0aXR1ZGUYASABKAESEQoJbG9uZ2l0dWRlGAIgASgBEg0KBWxhYmVsGAMgASgJEhUKDWFkZHJlc3NfbGluZXMYBCADKAkSEwoLcG9zdGFsX2NvZGUYBSABKAkSDAoEY2l0eRgGIAEoCRIUCgxjb3VudHJ5X2NvZGUYByABKAkSJAoEdHlwZRgIIAEoDjIWLm1vYmlsaXR5LnYxLlBsYWNlVHlwZSJNCgVQcmljZRIdChVhbW91bnRfaW5fbWlub3JfdW5pdHMYASABKAMSEAoIY3VycmVuY3kYAiABKAkSEwoLaXNfZXN0aW1hdGUYAyABKAgioAIKDFRyYW5zcG9ydExlZxIsCghzdGFydF9hdBgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASHgoRaXNfc3RhcnRfZmxleGlibGUYAiABKAhIAIgBARInCgtzdGFydF9wbGFjZRgDIAEoCzISLm1vYmlsaXR5LnYxLlBsYWNlEioKBmVuZF9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASHAoPaXNfZW5kX2ZsZXhpYmxlGAUgASgISAGIAQESJQoJZW5kX3BsYWNlGAYgASgLMhIubW9iaWxpdHkudjEuUGxhY2VCFAoSX2lzX3N0YXJ0X2ZsZXhpYmxlQhIKEF9pc19lbmRfZmxleGlibGUiXAoJVHJhbnNwb3J0EjIKDnRyYW5zcG9ydF90eXBlGAEgASgOMhoubW9iaWxpdHkudjEuVHJhbnNwb3J0VHlwZRINCgVsYWJlbBgCIAEoCRIMCgRsb2dvGAMgASgJItkBCgVGbGFncxIbChNpc19lYXJsaWVzdF9hcnJpdmFsGAEgASgIEhIKCmlzX2Zhc3Rlc3QYAiABKAgSEwoLaXNfY2hlYXBlc3QYAyABKAgSIQoZaGFzX2FjY2Vzc2liaWxpdHlfd2FybmluZxgEIAEoCBIbChNoYXNfbHVnZ2FnZV93YXJuaW5nGAUgASgIEiEKGXJlcXVpcmVzX21hbmFnZXJfYXBwcm92YWwYBiABKAgSJwofaGFzX2Fycml2YWxfbmVhcl9hZ2VuY3lfY2xvc3VyZRgHIAEoCCJdCgtDTzJFbWlzc2lvbhINCgVzY29yZRgBIAEoBRINCgVsYWJlbBgCIAEoCRITCgZmYWN0b3IYAyABKAlIAIgBARIQCgh2YWx1ZV9rZxgEIAEoAkIJCgdfZmFjdG9yIjAKBERhdGUSDAoEeWVhchgBIAEoBRINCgVtb250aBgCIAEoBRILCgNkYXkYAyABKAUioQEKCVRyYWluQ2FyZBIUCgxjYXJkX3R5cGVfaWQYASABKAkSDgoGbnVtYmVyGAIgASgJEikKDmVmZmVjdGl2ZV9kYXRlGAMgASgLMhEubW9iaWxpdHkudjEuRGF0ZRIvCg9leHBpcmF0aW9uX2RhdGUYBCABKAsyES5tb2JpbGl0eS52MS5EYXRlSACIAQFCEgoQX2V4cGlyYXRpb25fZGF0ZSLCAQoJUGFzc2VuZ2VyEhEKCWxhc3RfbmFtZRgCIAEoCRISCgpmaXJzdF9uYW1lGAMgASgJEg0KBWVtYWlsGAQgASgJEg0KBXBob25lGAUgASgJEiQKCWJpcnRoZGF0ZRgGIAEoCzIRLm1vYmlsaXR5LnYxLkRhdGUSJQoFY2FyZHMYByADKAsyFi5tb2JpbGl0eS52MS5UcmFpbkNhcmQSDwoCaWQYCCABKAlIAIgBAUIFCgNfaWRKBAgBEAJSBXRpdGxlIt0BChNSZW50YWxWZWhpY2xlRHJpdmVyEhIKCmZpcnN0X25hbWUYASABKAkSEQoJbGFzdF9uYW1lGAIgASgJEg0KBXBob25lGAMgASgJEiQKCWJpcnRoZGF0ZRgEIAEoCzIRLm1vYmlsaXR5LnYxLkRhdGUSFgoObGljZW5jZV9udW1iZXIYBSABKAkSMAoVbGljZW5jZV9kYXRlX29mX2lzc3VlGAYgASgLMhEubW9iaWxpdHkudjEuRGF0ZRIgChhsaWNlbmNlX2NvdW50cnlfb2ZfaXNzdWUYByABKAkihQEKBEZhcmUSFQoNcGFzc2VuZ2VyX2lkcxgBIAMoCRImCgVwcmljZRgCIAEoCzISLm1vYmlsaXR5LnYxLlByaWNlSACIAQESNAoNc2VnbWVudF9mYXJlcxgDIAMoCzIdLm1vYmlsaXR5LnYxLlRyYWluU2VnbWVudEZhcmVCCAoGX3ByaWNlInsKEFRyYWluU2VnbWVudEZhcmUSEgoKc2VnbWVudF9pZBgBIAEoCRINCgVsYWJlbBgCIAEoCRISCgpjb25kaXRpb25zGAMgASgJEiYKBXByaWNlGAQgASgLMhIubW9iaWxpdHkudjEuUHJpY2VIAIgBAUIICgZfcHJpY2UipQEKDFRyYWluU2VnbWVudBIpCgl0cmFuc3BvcnQYASABKAsyFi5tb2JpbGl0eS52MS5UcmFuc3BvcnQSJgoDbGVnGAIgASgLMhkubW9iaWxpdHkudjEuVHJhbnNwb3J0TGVnEhIKCnRyYWluX25hbWUYAyABKAkSEAoIbG9nb191cmwYBCABKAkSHAoUaXNfcHJpbWFyeV90cmFuc3BvcnQYBSABKAgqcgoJUGxhY2VUeXBlEhoKFlBMQUNFX1RZUEVfVU5TUEVDSUZJRUQQABIWChJQTEFDRV9UWVBFX1NUQVRJT04QARITCg9QTEFDRV9UWVBFX0NJVFkQAhIcChhQTEFDRV9UWVBFX1JFTlRBTF9BR0VOQ1kQAyqGAgoNVHJhbnNwb3J0VHlwZRIeChpUUkFOU1BPUlRfVFlQRV9VTlNQRUNJRklFRBAAEhgKFFRSQU5TUE9SVF9UWVBFX1RSQUlOEAESIQodVFJBTlNQT1JUX1RZUEVfUkVOVEFMX1ZFSElDTEUQAhIXChNUUkFOU1BPUlRfVFlQRV9UQVhJEAMSGAoUVFJBTlNQT1JUX1RZUEVfUExBTkUQBBIjCh9UUkFOU1BPUlRfVFlQRV9QRVJTT05BTF9WRUhJQ0xFEAUSJwojVFJBTlNQT1JUX1RZUEVfQ0hBVUZGRVVSRURfVFJBTlNGRVIQBhIXChNUUkFOU1BPUlRfVFlQRV9XQUxLEAcqZwoKVGF4aVRvd2FnZRIbChdUQVhJX1RPV0FHRV9VTlNQRUNJRklFRBAAEh0KGVRBWElfVE9XQUdFX1NNQUxMX1RSQUlMRVIQARIdChlUQVhJX1RPV0FHRV9MQVJHRV9UUkFJTEVSEAJCQFo+Z2l0aHViLmNvbS90aGV0cmVlcC9hNnRyL2JhY2tlbmQvZ2VuL2dvL21vYmlsaXR5L3YxO21vYmlsaXR5djFiBnByb3RvMw", [file_google_protobuf_timestamp, file_google_type_dayofweek, file_google_type_timeofday]);

/**
 * TransportAgency - rental or transport provider (e.g. car rental company, taxi operator).
 *
 * @generated from message mobility.v1.TransportAgency
 */
export type TransportAgency = Message<"mobility.v1.TransportAgency"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string full_address = 3;
   */
  fullAddress: string;

  /**
   * @generated from field: repeated mobility.v1.DayOpeningHours opening_hours = 4;
   */
  openingHours: DayOpeningHours[];

  /**
   * operates_on_call indicates that for this result, the agency is outside regular opening hours but accepts on-call bookings.
   *
   * @generated from field: bool operates_on_call = 5;
   */
  operatesOnCall: boolean;

  /**
   * @generated from field: string phone = 6;
   */
  phone: string;

  /**
   * @generated from field: string on_call_phone = 7;
   */
  onCallPhone: string;

  /**
   * @generated from field: bool out_of_opening_hours = 8;
   */
  outOfOpeningHours: boolean;

  /**
   * Agency logo, when the provider publishes one.
   *
   * @generated from field: string image_url = 9;
   */
  imageUrl: string;

  /**
   * offline marks an agency served from a6tr's own cache
   *
   * @generated from field: bool offline = 10;
   */
  offline: boolean;
};

/**
 * Describes the message mobility.v1.TransportAgency.
 * Use `create(TransportAgencySchema)` to create a new message.
 */
export const TransportAgencySchema: GenMessage<TransportAgency> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 0);

/**
 * DayOpeningHours - opening hours for a specific day of the week
 *
 * @generated from message mobility.v1.DayOpeningHours
 */
export type DayOpeningHours = Message<"mobility.v1.DayOpeningHours"> & {
  /**
   * @generated from field: google.type.DayOfWeek day_of_week = 1;
   */
  dayOfWeek: DayOfWeek;

  /**
   * @generated from field: repeated mobility.v1.OpeningPeriod intervals = 2;
   */
  intervals: OpeningPeriod[];
};

/**
 * Describes the message mobility.v1.DayOpeningHours.
 * Use `create(DayOpeningHoursSchema)` to create a new message.
 */
export const DayOpeningHoursSchema: GenMessage<DayOpeningHours> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 1);

/**
 * OpeningPeriod - opening interval for a transport agency, with open and close times.
 *
 * @generated from message mobility.v1.OpeningPeriod
 */
export type OpeningPeriod = Message<"mobility.v1.OpeningPeriod"> & {
  /**
   * @generated from field: google.type.TimeOfDay open_time = 1;
   */
  openTime?: TimeOfDay;

  /**
   * @generated from field: google.type.TimeOfDay close_time = 2;
   */
  closeTime?: TimeOfDay;
};

/**
 * Describes the message mobility.v1.OpeningPeriod.
 * Use `create(OpeningPeriodSchema)` to create a new message.
 */
export const OpeningPeriodSchema: GenMessage<OpeningPeriod> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 2);

/**
 * Place - geographic location with coordinates and address lines.
 *
 * @generated from message mobility.v1.Place
 */
export type Place = Message<"mobility.v1.Place"> & {
  /**
   * @generated from field: double latitude = 1;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 2;
   */
  longitude: number;

  /**
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * @generated from field: repeated string address_lines = 4;
   */
  addressLines: string[];

  /**
   * @generated from field: string postal_code = 5;
   */
  postalCode: string;

  /**
   * @generated from field: string city = 6;
   */
  city: string;

  /**
   * @generated from field: string country_code = 7;
   */
  countryCode: string;

  /**
   * @generated from field: mobility.v1.PlaceType type = 8;
   */
  type: PlaceType;
};

/**
 * Describes the message mobility.v1.Place.
 * Use `create(PlaceSchema)` to create a new message.
 */
export const PlaceSchema: GenMessage<Place> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 3);

/**
 * Price - monetary amount in ISO 4217 minor units (smallest currency unit).
 * amount_in_minor_units: already scaled to the ISO 4217 minor unit for the currency.
 *   Examples: 1250 for €12.50 (EUR exponent 2), 1250 for £12.50 (GBP exponent 2), 1250 for ¥1250 (JPY exponent 0).
 * currency: ISO 4217 code, e.g. "EUR", "GBP", "USD".
 * Frontend formatting example (JavaScript):
 *   const minorUnitExponent = getMinorUnitExponent(price.currency); // e.g. 2 for EUR, 0 for JPY, from ISO 4217 data
 *   const amount = price.amount_in_minor_units / 10 ** minorUnitExponent;
 *   new Intl.NumberFormat('fr-FR', { style: 'currency', currency: price.currency }).format(amount); // → "12,50 €" for EUR
 *
 * @generated from message mobility.v1.Price
 */
export type Price = Message<"mobility.v1.Price"> & {
  /**
   * @generated from field: int64 amount_in_minor_units = 1;
   */
  amountInMinorUnits: bigint;

  /**
   * @generated from field: string currency = 2;
   */
  currency: string;

  /**
   * @generated from field: bool is_estimate = 3;
   */
  isEstimate: boolean;
};

/**
 * Describes the message mobility.v1.Price.
 * Use `create(PriceSchema)` to create a new message.
 */
export const PriceSchema: GenMessage<Price> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 4);

/**
 * TransportLeg - one leg of a transport solution, with start/end places and times.
 *
 * @generated from message mobility.v1.TransportLeg
 */
export type TransportLeg = Message<"mobility.v1.TransportLeg"> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_at = 1;
   */
  startAt?: Timestamp;

  /**
   * @generated from field: optional bool is_start_flexible = 2;
   */
  isStartFlexible?: boolean;

  /**
   * @generated from field: mobility.v1.Place start_place = 3;
   */
  startPlace?: Place;

  /**
   * @generated from field: google.protobuf.Timestamp end_at = 4;
   */
  endAt?: Timestamp;

  /**
   * @generated from field: optional bool is_end_flexible = 5;
   */
  isEndFlexible?: boolean;

  /**
   * @generated from field: mobility.v1.Place end_place = 6;
   */
  endPlace?: Place;
};

/**
 * Describes the message mobility.v1.TransportLeg.
 * Use `create(TransportLegSchema)` to create a new message.
 */
export const TransportLegSchema: GenMessage<TransportLeg> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 5);

/**
 * Transport - mode of transport with its display label.
 *
 * @generated from message mobility.v1.Transport
 */
export type Transport = Message<"mobility.v1.Transport"> & {
  /**
   * @generated from field: mobility.v1.TransportType transport_type = 1;
   */
  transportType: TransportType;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string logo = 3;
   */
  logo: string;
};

/**
 * Describes the message mobility.v1.Transport.
 * Use `create(TransportSchema)` to create a new message.
 */
export const TransportSchema: GenMessage<Transport> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 6);

/**
 * Flags - various boolean flags for mobility solutions
 *
 * @generated from message mobility.v1.Flags
 */
export type Flags = Message<"mobility.v1.Flags"> & {
  /**
   * @generated from field: bool is_earliest_arrival = 1;
   */
  isEarliestArrival: boolean;

  /**
   * @generated from field: bool is_fastest = 2;
   */
  isFastest: boolean;

  /**
   * @generated from field: bool is_cheapest = 3;
   */
  isCheapest: boolean;

  /**
   * @generated from field: bool has_accessibility_warning = 4;
   */
  hasAccessibilityWarning: boolean;

  /**
   * @generated from field: bool has_luggage_warning = 5;
   */
  hasLuggageWarning: boolean;

  /**
   * @generated from field: bool requires_manager_approval = 6;
   */
  requiresManagerApproval: boolean;

  /**
   * @generated from field: bool has_arrival_near_agency_closure = 7;
   */
  hasArrivalNearAgencyClosure: boolean;
};

/**
 * Describes the message mobility.v1.Flags.
 * Use `create(FlagsSchema)` to create a new message.
 */
export const FlagsSchema: GenMessage<Flags> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 7);

/**
 * CO2Emission - estimated carbon footprint for a mobility solution.
 *
 * @generated from message mobility.v1.CO2Emission
 */
export type CO2Emission = Message<"mobility.v1.CO2Emission"> & {
  /**
   * @generated from field: int32 score = 1;
   */
  score: number;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: optional string factor = 3;
   */
  factor?: string;

  /**
   * @generated from field: float value_kg = 4;
   */
  valueKg: number;
};

/**
 * Describes the message mobility.v1.CO2Emission.
 * Use `create(CO2EmissionSchema)` to create a new message.
 */
export const CO2EmissionSchema: GenMessage<CO2Emission> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 8);

/**
 * Date - calendar date without timezone (year/month/day).
 *
 * @generated from message mobility.v1.Date
 */
export type Date = Message<"mobility.v1.Date"> & {
  /**
   * @generated from field: int32 year = 1;
   */
  year: number;

  /**
   * Month of year. Must be from 1 to 12
   *
   * @generated from field: int32 month = 2;
   */
  month: number;

  /**
   * Day of month. Must be from 1 to 31 and valid for the year and month
   *
   * @generated from field: int32 day = 3;
   */
  day: number;
};

/**
 * Describes the message mobility.v1.Date.
 * Use `create(DateSchema)` to create a new message.
 */
export const DateSchema: GenMessage<Date> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 9);

/**
 * TrainCard - loyalty or reduction card held by a passenger, used to apply discounted fares.
 * card_type_id references card.v1.CardType.id from CardService.ListCards.
 *
 * @generated from message mobility.v1.TrainCard
 */
export type TrainCard = Message<"mobility.v1.TrainCard"> & {
  /**
   * @generated from field: string card_type_id = 1;
   */
  cardTypeId: string;

  /**
   * @generated from field: string number = 2;
   */
  number: string;

  /**
   * @generated from field: mobility.v1.Date effective_date = 3;
   */
  effectiveDate?: Date;

  /**
   * @generated from field: optional mobility.v1.Date expiration_date = 4;
   */
  expirationDate?: Date;
};

/**
 * Describes the message mobility.v1.TrainCard.
 * Use `create(TrainCardSchema)` to create a new message.
 */
export const TrainCardSchema: GenMessage<TrainCard> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 10);

/**
 * Passenger - traveller details required for train booking.
 *
 * @generated from message mobility.v1.Passenger
 */
export type Passenger = Message<"mobility.v1.Passenger"> & {
  /**
   * @generated from field: string last_name = 2;
   */
  lastName: string;

  /**
   * @generated from field: string first_name = 3;
   */
  firstName: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: string phone = 5;
   */
  phone: string;

  /**
   * @generated from field: mobility.v1.Date birthdate = 6;
   */
  birthdate?: Date;

  /**
   * @generated from field: repeated mobility.v1.TrainCard cards = 7;
   */
  cards: TrainCard[];

  /**
   * @generated from field: optional string id = 8;
   */
  id?: string;
};

/**
 * Describes the message mobility.v1.Passenger.
 * Use `create(PassengerSchema)` to create a new message.
 */
export const PassengerSchema: GenMessage<Passenger> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 11);

/**
 * RentalVehicleDriver - driver details required for rental vehicle booking.
 *
 * @generated from message mobility.v1.RentalVehicleDriver
 */
export type RentalVehicleDriver = Message<"mobility.v1.RentalVehicleDriver"> & {
  /**
   * @generated from field: string first_name = 1;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 2;
   */
  lastName: string;

  /**
   * @generated from field: string phone = 3;
   */
  phone: string;

  /**
   * @generated from field: mobility.v1.Date birthdate = 4;
   */
  birthdate?: Date;

  /**
   * @generated from field: string licence_number = 5;
   */
  licenceNumber: string;

  /**
   * @generated from field: mobility.v1.Date licence_date_of_issue = 6;
   */
  licenceDateOfIssue?: Date;

  /**
   * @generated from field: string licence_country_of_issue = 7;
   */
  licenceCountryOfIssue: string;
};

/**
 * Describes the message mobility.v1.RentalVehicleDriver.
 * Use `create(RentalVehicleDriverSchema)` to create a new message.
 */
export const RentalVehicleDriverSchema: GenMessage<RentalVehicleDriver> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 12);

/**
 * Fare - fare conditions and pricing for one or more passengers on a train offer.
 * passenger_ids references passengers from the enclosing SearchForm or TrainForm.
 *
 * @generated from message mobility.v1.Fare
 */
export type Fare = Message<"mobility.v1.Fare"> & {
  /**
   * One or more passengers covered by this fare (e.g. a group or family ticket).
   *
   * @generated from field: repeated string passenger_ids = 1;
   */
  passengerIds: string[];

  /**
   * @generated from field: optional mobility.v1.Price price = 2;
   */
  price?: Price;

  /**
   * @generated from field: repeated mobility.v1.TrainSegmentFare segment_fares = 3;
   */
  segmentFares: TrainSegmentFare[];
};

/**
 * Describes the message mobility.v1.Fare.
 * Use `create(FareSchema)` to create a new message.
 */
export const FareSchema: GenMessage<Fare> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 13);

/**
 * TrainSegmentFare - fare label, conditions and optional price for one train segment.
 *
 * @generated from message mobility.v1.TrainSegmentFare
 */
export type TrainSegmentFare = Message<"mobility.v1.TrainSegmentFare"> & {
  /**
   * references TrainSegment in the enclosing solution
   *
   * @generated from field: string segment_id = 1;
   */
  segmentId: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string conditions = 3;
   */
  conditions: string;

  /**
   * @generated from field: optional mobility.v1.Price price = 4;
   */
  price?: Price;
};

/**
 * Describes the message mobility.v1.TrainSegmentFare.
 * Use `create(TrainSegmentFareSchema)` to create a new message.
 */
export const TrainSegmentFareSchema: GenMessage<TrainSegmentFare> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 14);

/**
 * TrainSegment - shared type used in both search and booking.
 *
 * @generated from message mobility.v1.TrainSegment
 */
export type TrainSegment = Message<"mobility.v1.TrainSegment"> & {
  /**
   * @generated from field: mobility.v1.Transport transport = 1;
   */
  transport?: Transport;

  /**
   * @generated from field: mobility.v1.TransportLeg leg = 2;
   */
  leg?: TransportLeg;

  /**
   * @generated from field: string train_name = 3;
   */
  trainName: string;

  /**
   * @generated from field: string logo_url = 4;
   */
  logoUrl: string;

  /**
   * @generated from field: bool is_primary_transport = 5;
   */
  isPrimaryTransport: boolean;
};

/**
 * Describes the message mobility.v1.TrainSegment.
 * Use `create(TrainSegmentSchema)` to create a new message.
 */
export const TrainSegmentSchema: GenMessage<TrainSegment> = /*@__PURE__*/
  messageDesc(file_mobility_v1_common, 15);

/**
 * PlaceType - the kind of location a Place represents.
 *
 * @generated from enum mobility.v1.PlaceType
 */
export enum PlaceType {
  /**
   * @generated from enum value: PLACE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLACE_TYPE_STATION = 1;
   */
  STATION = 1,

  /**
   * @generated from enum value: PLACE_TYPE_CITY = 2;
   */
  CITY = 2,

  /**
   * @generated from enum value: PLACE_TYPE_RENTAL_AGENCY = 3;
   */
  RENTAL_AGENCY = 3,
}

/**
 * Describes the enum mobility.v1.PlaceType.
 */
export const PlaceTypeSchema: GenEnum<PlaceType> = /*@__PURE__*/
  enumDesc(file_mobility_v1_common, 0);

/**
 * TransportType - mode of transport for a mobility solution.
 *
 * @generated from enum mobility.v1.TransportType
 */
export enum TransportType {
  /**
   * @generated from enum value: TRANSPORT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSPORT_TYPE_TRAIN = 1;
   */
  TRAIN = 1,

  /**
   * @generated from enum value: TRANSPORT_TYPE_RENTAL_VEHICLE = 2;
   */
  RENTAL_VEHICLE = 2,

  /**
   * @generated from enum value: TRANSPORT_TYPE_TAXI = 3;
   */
  TAXI = 3,

  /**
   * @generated from enum value: TRANSPORT_TYPE_PLANE = 4;
   */
  PLANE = 4,

  /**
   * @generated from enum value: TRANSPORT_TYPE_PERSONAL_VEHICLE = 5;
   */
  PERSONAL_VEHICLE = 5,

  /**
   * A rental agency drives the customer itself instead of a taxi being booked ("mobilité déléguée").
   *
   * @generated from enum value: TRANSPORT_TYPE_CHAUFFEURED_TRANSFER = 6;
   */
  CHAUFFEURED_TRANSFER = 6,

  /**
   * A gap covered on foot, too short for a ground transfer: nothing to choose, book or pay for.
   *
   * @generated from enum value: TRANSPORT_TYPE_WALK = 7;
   */
  WALK = 7,
}

/**
 * Describes the enum mobility.v1.TransportType.
 */
export const TransportTypeSchema: GenEnum<TransportType> = /*@__PURE__*/
  enumDesc(file_mobility_v1_common, 1);

/**
 * TaxiTowage - type of trailer to be towed by the taxi, if any.
 *
 * @generated from enum mobility.v1.TaxiTowage
 */
export enum TaxiTowage {
  /**
   * @generated from enum value: TAXI_TOWAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TAXI_TOWAGE_SMALL_TRAILER = 1;
   */
  SMALL_TRAILER = 1,

  /**
   * @generated from enum value: TAXI_TOWAGE_LARGE_TRAILER = 2;
   */
  LARGE_TRAILER = 2,
}

/**
 * Describes the enum mobility.v1.TaxiTowage.
 */
export const TaxiTowageSchema: GenEnum<TaxiTowage> = /*@__PURE__*/
  enumDesc(file_mobility_v1_common, 2);

